































































































































































































import { Component, Watch, Vue } from "vue-property-decorator";
import { indexSearchApi } from "@/api/home";
@Component({
  name: "classDetail",
  components: {},
})
export default class extends Vue {
  showStudent = true;
  showClass = true;
  showCourse = true;
  showStaff = true;
  showMenu = true;
  num: number = 1;
  studentNum: number = 1;
  classNum: number = 1;
  courseNum: number = 1;
  staffNum: number = 1;
  menuNum: number = 1;
  studentList = [];
  classList = [];
  courseList = [];
  staffList = [];
  menuList = [];
  SearchName = "";
  showStudentLoad = true;
  showClassLoad = true;
  showCourseLoad = true;
  showStaffLoad = true;
  showMenuLoad = true;
  created() {
    this.SearchName = this.$route.query.name;
    indexSearchApi({
      page: this.num,
      page_size: 10,
      key_word: this.SearchName,
    }).then((res: any) => {
      if (res.error_code === 0) {
        const _class = res.data.class;
        const _menu = res.data.menu;
        const _staff = res.data.staff;
        const _student = res.data.student;
        const _course = res.data.course;
        if (_class.list.length > 0) {
          this.classList = _class.list;
        }
        if (_class.total <= 10) {
          this.showClassLoad = false;
        }
        if (_class.total === 0) {
          this.showClass = false;
        }
        if (_menu.list.length > 0) {
          this.menuList = _menu.list;
        }
        if (_menu.total <= 10) {
          this.showMenuLoad = false;
        }
        if (_menu.total === 0) {
          this.showMenu = false;
        }
        if (_staff.list.length > 0) {
          this.staffList = _staff.list;
        }
        if (_staff.total <= 10) {
          this.showStaffLoad = false;
        }
        if (_staff.total === 0) {
          this.showStaff = false;
        }
        if (_student.list.length > 0) {
          this.studentList = _student.list;
        }
        if (_student.total <= 10) {
          this.showStudentLoad = false;
        }
        if (_student.total === 0) {
          this.showStudent = false;
        }
        if (_course.list.length > 0) {
          this.courseList = _course.list;
        }
        if (_course.total <= 10) {
          this.showCourseLoad = false;
        }
        if (_course.total === 0) {
          this.showCourse = false;
        }
      }
    });
  }
  loadingStudent() {
    indexSearchApi({
      page: (this.studentNum += 1),
      page_size: 10,
      key_word: this.SearchName,
    }).then((res: any) => {
      if (res.error_code === 0) {
        if (res.data.student.list.length > 0) {
          res.data.student.list.map((item: never) => {
            this.studentList.push(item);
          });
        }
        if (res.data.student.list.length < 10) {
          this.showStudentLoad = false;
        }
      }
    });
  }
  loadingClass() {
    indexSearchApi({
      page: (this.classNum += 1),
      page_size: 10,
      key_word: this.SearchName,
    }).then((res: any) => {
      if (res.error_code === 0) {
        if (res.data.class.list.length > 0) {
          res.data.class.list.map((item: never) => {
            this.classList.push(item);
          });
        }
        if (res.data.class.list.length < 10) {
          this.showClassLoad = false;
        }
      }
    });
  }
  loadingCourse() {
    indexSearchApi({
      page: (this.courseNum += 1),
      page_size: 10,
      key_word: this.SearchName,
    }).then((res: any) => {
      if (res.error_code === 0) {
        if (res.data.course.list.length > 0) {
          res.data.course.list.map((item: never) => {
            this.courseList.push(item);
          });
        }
        if (res.data.course.list.length < 10) {
          this.showCourseLoad = false;
        }
      }
    });
  }
  loadingStaff() {
    indexSearchApi({
      page: (this.staffNum += 1),
      page_size: 10,
      key_word: this.SearchName,
    }).then((res: any) => {
      if (res.error_code === 0) {
        if (res.data.staff.list.length > 0) {
          res.data.staff.list.map((item: never) => {
            this.staffList.push(item);
          });
        }
        if (res.data.staff.list.length < 10) {
          this.showStaffLoad = false;
        }
      }
    });
  }
  loadingMenu() {
    indexSearchApi({
      page: (this.menuNum += 1),
      page_size: 10,
      key_word: this.SearchName,
    }).then((res: any) => {
      if (res.error_code === 0) {
        if (res.data.menu.list.length > 0) {
          res.data.menu.list.map((item: never) => {
            this.menuList.push(item);
          });
        }
        if (res.data.menu.list.length < 10) {
          this.showMenuLoad = false;
        }
      }
    });
  }
  goDetail(n: string, id?: any) {
    this.$router.push({
      name: n,
      query: {
        id: id,
      },
    });
  }
  goLayout() {
    this.$router.push({
      path: "/",
    });
  }
}
